import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mode-refresh-in-progress',
  templateUrl: './refresh-in-progress.component.html',
  styleUrls: ['./refresh-in-progress.component.scss'],
})
export class RefreshInProgressComponent {
  constructor() {}
}
